import { useEffect, useState } from "react";

function useTRAAgeHook(
  initialAge = 0,
  minAge = 50,
  maxAge = 75,
  currentAge = 50,
) {
  const [ageCount, setCount] = useState(initialAge);
  const [showError, setShowError] = useState(false);

  const incrementAge = () => {
    setCount((prevCount) => (prevCount < maxAge ? prevCount + 1 : prevCount));
  };

  const decrementAge = () => {
    if (currentAge >= ageCount && currentAge != minAge) {
      setShowError(true);
    } else {
      setCount((prevCount) => (prevCount > minAge ? prevCount - 1 : prevCount));
    }
  };
  const reset = () => {
    setCount(initialAge);
  };
  useEffect(() => {
    if (showError) {
      setShowError(false);
    }
  }, [ageCount]);

  return {
    ageCount,
    incrementAge,
    decrementAge,
    reset,
    showError,
  };
}

export default useTRAAgeHook;
